import { useCallback, useEffect, useState } from 'react';
import { Modal, Button, Popconfirm, Input } from 'antd';
import { Container } from '@/ui';
import { useTranslation } from 'react-i18next';
import { Label, Space } from '@/features/constructorCommon/styled';
import { useProductLink } from '@/features/constructorProducts/hooks';

export const UpdateProductLinkModal = ({ open, onClose, selectedItem }) => {
  const { t } = useTranslation();
  const { handleUpdate } = useProductLink();
  const [data, setData] = useState({});

  useEffect(() => {
    if (selectedItem) {
      setData(selectedItem);
    }
  }, [selectedItem]);

  const onChange = useCallback((e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleClose = useCallback(() => {
    setData({});
    onClose();
  }, [onClose]);

  const handleUpdateLink = useCallback(() => {
    handleUpdate({
      productLinkId: selectedItem.id,
      ...data
    }).then(() => {
      handleClose();
    });
  }, [handleUpdate, selectedItem, data, handleClose]);

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      title={t('Update link')}
      footer={[
        <Button key='back' onClick={handleClose}>
          {t('Cancel')}
        </Button>,
        <Popconfirm
          title={t('Update link')}
          description={t('Are you sure you want to update the link?')}
          okText={t('Yes')}
          cancelText={t('No')}
          onConfirm={() => handleUpdateLink()}
        >
          <Button type='primary' style={{ marginLeft: '4px' }}>
            {t('Update')}
          </Button>
        </Popconfirm>
      ]}
    >
      <Container $marginTop={16} $marginBottom={10}>
        <Label>{t('Title')}</Label>
        <Input name='name' value={data.name} onChange={onChange} />
        <Space />
        <Label>{`${t('Title')} (RU)`}</Label>
        <Input name='name_RU' value={data.name_RU} onChange={onChange} />
        <Space />
        <Label>{`${t('Title')} (LV)`}</Label>
        <Input name='name_LV' value={data.name_LV} onChange={onChange} />
        <Space />
        <Label>{t('Link')}</Label>
        <Input name='link' value={data.link} onChange={onChange} />
        <Space />
      </Container>
    </Modal>
  );
};
